module.exports = __webpack_public_path__ + "img/TENNIS_COURT.5b7a7b15.svg";